import { Component, OnInit, OnChanges, Input, EventEmitter, Output, forwardRef, SimpleChanges, ViewChild, ElementRef, NgZone } from '@angular/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { TranslateService } from '@ngx-translate/core';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';

@Component({
    selector: 'adahi-file-upload',
    templateUrl: './file-upload.component.html',
})
export class FileUploadComponent extends BaseTranslation implements OnInit {

    appSettings: IAppConfig;
    file: File = null;
    files: File[] = [];
    typeError: boolean = false;
    nameError: boolean = false;
    fileSizeError: boolean = false;
    filePlaceholder: string = '';

    @ViewChild('fileRef')
    fileRef: ElementRef;

    @Output()
    fileChanged = new EventEmitter<any>();

    @Input('allowedTypes')
    allowedTypes: string = '';

    @Input('clearAfterUpload')
    clearAfterUpload: boolean = false;

    @Input('allowedTypesText')
    allowedTypesText: string;

    @Input('multiple')
    multipleUpload: boolean = false;

    @Input('addedNotes')
    addedNotes: string;

    constructor(translateService: TranslateService, ngZone: NgZone) {
        super(translateService, ngZone);
        this.appSettings = AppConfig.settings;
    }

    ngOnInit() {
        this.translate.get("common.ChooseFile").subscribe(trans => {
            this.filePlaceholder = trans;
        })
        if (this.allowedTypes === '') {
            this.allowedTypes = this.appSettings.allowedFileTypes;
        }
    }

    handleFile(files) {

        if (files == null || !files.item(0)) return;

        let fileName = '';
        if (this.multipleUpload) {
            for (let i = 0; i < files.length; i++) {
                if (i != 0) fileName += ', ';
                fileName += files.item(i).name;
            }
        } else {
            fileName = files.item(0).name;
        }


        let fileSize: number = 0;

        if (this.multipleUpload) {
            for (let i = 0; i < files.length; i++) {
                if (i != 0) fileName += ', ';
                fileSize += +files.item(i).size;
            }
        } else {
            fileSize = files.item(0).size;
        }

        if (fileSize > 5000000) {
            this.fileSizeError = true;
            this.fileRef.nativeElement.value = '';
            return;
        } else {
            this.fileSizeError = false;
        }

        if (!this.multipleUpload) {
            if (fileName.length > 50) {
                this.nameError = true;
                this.fileRef.nativeElement.value = '';
                return;
            } else {
                this.nameError = false;
            }
        }


        if (this.multipleUpload) {
            for (let i = 0; i < files.length; i++) {
                let extension: string = files.item(i).name.split('.')[files.item(i).name.split('.').length - 1];

                extension = extension.toLowerCase();

                if (!this.allowedTypes.includes(extension)) {
                    this.fileRef.nativeElement.value = '';
                    this.typeError = true;
                    setTimeout(() => {
                        this.typeError = false;
                    }, 3000);
                    return;
                }
            }
        } else {
            let extension: string = fileName.split('.')[fileName.split('.').length - 1];

            extension = extension.toLowerCase();

            if (!this.allowedTypes.includes(extension)) {
                this.fileRef.nativeElement.value = '';
                this.typeError = true;
                setTimeout(() => {
                    this.typeError = false;
                }, 3000);
                return;
            }
        }


        if (this.multipleUpload) {
            this.files = files;
        } else {
            this.file = files.item(0);
        }

        this.fileRef.nativeElement.placeholder = fileName;
        if (this.multipleUpload) {
            this.fileChanged.emit(this.files);
        } else {
            this.fileChanged.emit(this.file);
        }
        this.filePlaceholder = fileName;

        if (this.clearAfterUpload) {
            this.clear();
        }
    }

    public clear() {
        this.file = null;
        this.files = [];
        this.fileRef.nativeElement.placeholder = '';
        if (this.multipleUpload) {
            this.fileChanged.emit(this.files);
        } else {
            this.fileChanged.emit(this.file);
        }
        this.filePlaceholder = this.translate.instant('common.ChooseFile');
    }
}